<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <FiltroNotasFiscais/>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import FiltroNotasFiscais from '@/router/views/admin/nfse/components/filtro-nfse.vue'
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Consulta de Notas Fiscais",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    FiltroNotasFiscais
  },
  props: {
    tipo: {
      type: String
    },
  },
  data() {
    return {
      title: "Consulta de Notas Fiscais",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Relatório de Notas Fiscais',
          active: true,
        },
      ],
    };
  }
};
</script>


